"use client";

import {
  FeatureHighlight,
  MainLink,
  SecondaryLink,
  TitleH2,
} from "@/components/shared/public";
import { Separator } from "@/components/ui/separator";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { salzesOptExamp } from "../../../../public/images/floor-plans";
import { floorPlanDetail } from "../../../../public/images/logos";

const ProductDescription = () => {
  const t = useTranslations("salesOptimizedFloorPlans.productDescription");

  return (
    <div className="gs--page-column py-16">
      <div className="flex flex-col gap-10">
        <FeatureHighlight
          src={floorPlanDetail}
          alt={"floor plan logo"}
          title={t("title")}
          text={t("text")}
        />

        {/* Explanation */}
        <div className="flex flex-col items-center gap-10 md:flex-row">
          <div className="flex flex-col gap-10">
            <Separator />
            <p className="text-ring">{t("explanation")}</p>
            <Separator />
          </div>
          <Image
            src={salzesOptExamp}
            alt={"Beispiel verkaufsoptimierter Grundriss"}
            width={400}
            className="w-[400px]"
            loading="lazy"
          />
        </div>

        {/* Suggestion */}
        <div className="text-ring flex flex-col gap-5">
          <TitleH2 title={t("suggestion.title")} />
          <p>{t("suggestion.text")}</p>
          <p>{t("suggestion.text2")}</p>
          <p>{t("suggestion.text3")}</p>
          <p>{t("suggestion.text4")}</p>
          <p>{t("suggestion.text5")}</p>
          <p>{t("suggestion.text6")}</p>

          <div className="flex-start mt-5 flex flex-col gap-5 sm:flex-row sm:items-center">
            <MainLink
              href="/user/order-sales-optimized-floor-plan"
              title={t("suggestion.mainLink")}
            />
            <SecondaryLink
              href={"/grundriss-designs"}
              title={t("suggestion.secondaryLink")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDescription;
